export default "__VITE_ASSET__HwKtVnCL__"